export default {
  Title: 'Thiết lập in báo cáo',
  Report: 'Báo cáo',
  Signer: 'Người ký',
  GetDefault: 'Lấy lại mặc định',
  Cancel: 'Hủy',
  FontFormat: 'Định dạng font chữ',
  QHNSCode: 'Mã QHNS',
  Province: 'Thành phố: {0}',
  District: 'Quận: {0}',
  Ward: 'Phường : {0}',
  CompanyCode: 'Mã QHNS: {0}',
  CapitalizeLetter: 'Chữ in hoa',
  PrintOptions: 'Tùy chọn in',
  ShowSignDateBy: 'Hiển thị ngày ký theo',
  SignerInUnit: 'Người ký trong đơn vị',
  UnitInformation: 'Thông tin đơn vị',
  PrintLicenseEstimateForm: 'In giấy phép sử dụng trên các mẫu dự toán',
  ShowDBHCInVoucher: 'Hiển thị mã ĐBHC trên chứng từ',
  ShowPlaceNameInVoucherAndReport: 'Hiển thị tên địa danh trên chứng từ, báo cáo',
  CurrentDate: 'Ngày hiện tại',
  VoucherDate: 'Ngày chứng từ',
  Empty: 'Bỏ trống',
  EnterPlaceName: 'Nhập tên địa danh',
  // Tab người ký
  PrintNameOnReport: 'In tên trên báo cáo',
  NotPrintNameSignerOnTreasuryVoucher: 'Không in tên Người ký trên chứng từ kho bạc',
  Upper: 'AA',
  Lower: 'Aa',
  Success: 'Cập nhật thành công',
  ShowReceiptEnoughMoneyOnCAPayment: 'Hiển thị đã nhận đủ số tiền trên Phiếu chi',
  ShowReceiptEnoughMoneyOnCAReceipt: 'Hiển thị đã nhận đủ số tiền trên Phiếu thu',
  ReportSortSettingLable: 'Sắp xếp',
};
